module.exports = __webpack_public_path__ + "static/media/userProfileIcon.d8d84260.svg";